var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconQuestionsAndPosts(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.7352 1.41811V7.91117H4.24213V1.41811H10.7352ZM10.7352 0.335938H4.24213C3.64694 0.335938 3.15996 0.822917 3.15996 1.41811V7.91117C3.15996 8.50637 3.64694 8.99335 4.24213 8.99335H10.7352C11.3304 8.99335 11.8174 8.50637 11.8174 7.91117V1.41811C11.8174 0.822917 11.3304 0.335938 10.7352 0.335938ZM6.13594 5.56826L7.05038 6.79112L8.39228 5.11374L10.1941 7.37008H4.78322L6.13594 5.56826ZM0.995605 2.50029V10.0755C0.995605 10.6707 1.48258 11.1577 2.07778 11.1577H9.65301V10.0755H2.07778V2.50029H0.995605Z",
    fill: "#3456FF"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconQuestionsAndPosts);
export default __webpack_public_path__ + "static/media/icon-questions-and-posts.c7f4b19e721192af0c281a2dd3bd262d.svg";
export { ForwardRef as ReactComponent };